import { createReducer } from '@reduxjs/toolkit'
import { managerActions } from '@store/reducers/manager/actions'

import { InternalCommentReadsActions } from './actions'
import { UNREAD } from './constants'
import type { CommentReadsState } from './types'

// the mark only moves forward, the same rule the server applies; the one way
// back is the explicit reset of Mark as unread
const nextMark = (current: number | undefined, readAt: number): number => {
  if (readAt === UNREAD) {
    return UNREAD
  }

  return Math.max(current ?? 0, readAt)
}

export const commentReadsReducer = createReducer<CommentReadsState>(
  {},
  (builder) => {
    builder
      .addCase(InternalCommentReadsActions.set, (_, { payload }) => payload)
      // marks belong to one project: a newly loaded one shows none until its
      // own map arrives, rather than the previous project's for a moment
      .addCase(managerActions.loadProject, () => ({}))
      .addCase(
        InternalCommentReadsActions.update,
        (state, { payload: { target, readAt } }) => ({
          ...state,
          [target]: nextMark(state[target], readAt),
        })
      )
  }
)
